module.exports = __webpack_public_path__ + "static/media/vehicle.c069e6e9.jpg";